var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.9961C4.77614 1.9961 5 2.21952 5 2.49513C5 2.77073 4.77614 2.99415 4.5 2.99415H1V8.98246H7V5.48928C7 5.21367 7.22386 4.99025 7.5 4.99025C7.77614 4.99025 8 5.21367 8 5.48928V8.98246C8 9.53366 7.55228 9.98051 7 9.98051H1C0.447715 9.98051 0 9.53366 0 8.98246V2.99415C0 2.44294 0.447715 1.9961 1 1.9961H4.5ZM9 0C9.55228 0 10 0.446842 10 0.998051V3.49318C10 3.76878 9.77614 3.9922 9.5 3.9922C9.22386 3.9922 9 3.76878 9 3.49318V1.70267L3.85355 6.84019C3.65829 7.03508 3.34171 7.03508 3.14645 6.84019C2.95118 6.64531 2.95118 6.32935 3.14645 6.13446L8.292 0.998051H6.5C6.22386 0.998051 6 0.774629 6 0.499025C6 0.223421 6.22386 0 6.5 0H9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.5814a7ada9c3cff904397e42495f5704.svg";
export { ForwardRef as ReactComponent };